/**
 * Classe com a funcionalidade de menu.
 * @author: adalto.junior
 * Date: 15/10/13
 * Time: 12:00
 */

import { navigateToRouteDetailsFocusedOnStop } from 'react/utils/routeDetails';
import { DefaultRequest } from 'scripts/api';

Greenmile.RouteSummary = Greenmile.RouteSummary || {};
Greenmile.RouteSummary.Stops = Greenmile.RouteSummary.Stops || {};

Greenmile.RouteSummary.Stops.Menu = (function () {
  function Menu() {
    Greenmile.Grid.Menu.apply(this, arguments);

    const actionGridMenu = {
      ARRIVE_AT_STOP_DESTINATION: 'btn_arrive_at_stop_menu',
      CANCEL_STOP: 'btn_cancel_stop_menu',
      DEPART_FROM_STOP: 'btn_depart_from_stop_menu',
      REDELIVERY_STOP: 'btn_redelivery_stop_menu',
      UNDELIVERABLE_STOP: 'btn_undeliverable_stop_menu',
      SHOW_STOP_ON_ROUTE_DETAIL: 'show_stop_on_route_detail'
    };

    this.beforeRenderMenu = function (renderMenu) {
      const criteriaChain = {
        criteriaChain: [
          {
            and: [
              {
                eq: this.model.get('stop').id,
                attr: 'stops.id'
              }
            ]
          }
        ]
      };
      const request = new DefaultRequest({
        method: 'post',
        url: 'Route/restrictions?criteria={"filters":["id","status", "key", "actualStart", "stops.id", "driverAssignments.id", "driverAssignments.driver.id", "equipmentAssignments.id", "equipmentAssignments.equipment.id"]}',
        data: criteriaChain,
        success: function (result) {
          this.model.attributes.route = result[0];
          renderMenu();
        }.bind(this)
      });
      request.send();
      renderMenu();
    };

    function getListOrdersMenuItem({ location, gridMenu, stop }) {
      if (!location) return null;
      return {
        id: 1,
        description: Monet.I18n.getResourcesByKey('Greenmile.Stop.ListOrders'),
        icon: 'viewOrdersAndItems',
        customClassname: 'ViewOrdersItem',
        action: function () {
          gridMenu.removeAllMenus();
          App.Forms.RouteSummaryOrders.stop = stop;
          Monet.Grid.Utils.clearPagination('RouteSummaryOrders');
          const hash = '#/RouteSummary/OrderAndLineItems';
          if (hash === window.location.hash) {
            App.Views.RouteSummary.showOrdersAndLineItems();
          } else {
            window.location = hash;
          }
        }
      };
    }

    function getArriveMenuItem({
      allowArrive,
      enabledMenus,
      actionGridMenu,
      gridMenu,
      model,
      routeId
    }) {
      if (
        !allowArrive ||
        !enabledMenus.isEnabled(actionGridMenu.ARRIVE_AT_STOP_DESTINATION)
      )
        return null;
      return {
        id: 2,
        description: Monet.I18n.getResourcesByKey(
          'Greenmile.Stop.Arrive.btnSave'
        ),
        icon: 'arriveStop',
        customClassname: 'ArriveStopItem',
        action: function () {
          if (model.get('route').driverAssignments?.length) {
            const arriveStopPopup = new Greenmile.Stop.Arrive();
            gridMenu.removeAllMenus();
            arriveStopPopup.setStop(model);
            arriveStopPopup.setRouteId(routeId);
            arriveStopPopup.show();
            return;
          }
          window.globalStore.dispatch({
            type: window.actions.routeSummary.actions.missingDriverModal.OPEN_MODAL,
            payload: { stopCandidate: model }
          });
        }
      };
    }

    function getCancelMenuItem({
      allowCancel,
      enabledMenus,
      actionGridMenu,
      gridMenu,
      stop,
      routeId
    }) {
      if (!allowCancel || !enabledMenus.isEnabled(actionGridMenu.CANCEL_STOP))
        return null;
      return {
        id: 3,
        description: Monet.I18n.getResourcesByKey(
          'Greenmile.Route.ArriveDestination.PendingStops.btnSave'
        ),
        icon: 'cancelStop',
        customClassname: 'CancelStopItem',
        action: function () {
          const cancelStopPopup = new Greenmile.Stop.Cancel();
          gridMenu.removeAllMenus();
          cancelStopPopup.setStop(stop.get('key'));
          cancelStopPopup.setRouteId(routeId);
          cancelStopPopup.show();
        }
      };
    }

    function getDepartMenuItem({
      allowDepart,
      enabledMenus,
      actionGridMenu,
      gridMenu,
      model,
      routeId
    }) {
      if (
        !allowDepart ||
        !enabledMenus.isEnabled(actionGridMenu.DEPART_FROM_STOP)
      )
        return null;
      return {
        id: 4,
        description: Monet.I18n.getResourcesByKey(
          'Greenmile.Stop.Depart.btnSave'
        ),
        icon: 'departStop',
        customClassname: 'DepartStopItem',
        action: function () {
          const departStopPopup = new Greenmile.Stop.Depart();
          gridMenu.removeAllMenus();
          departStopPopup.setStop(model);
          departStopPopup.setRouteId(routeId);
          departStopPopup.show();
        }
      };
    }

    function getRedeliveryStopMenuItem({
      allowRedelivery,
      location,
      enabledMenus,
      actionGridMenu,
      gridMenu,
      model,
      routeId
    }) {
      if (!allowRedelivery || !location) return null;
      if (!enabledMenus.isEnabled(actionGridMenu.REDELIVERY_STOP)) return null;
      return {
        id: 5,
        description: Monet.I18n.getResourcesByKey(
          'event.check.undeliverablestop'
        ),
        icon: 'returnStop',
        customClassname: 'ReturnStopItem',
        action: function () {
          const returnStopPopup = new Greenmile.Stop.Return();
          gridMenu.removeAllMenus();
          returnStopPopup.setStop(model);
          returnStopPopup.setRouteId(routeId);
          returnStopPopup.show();
        }
      };
    }

    function getUndeliverableStopMenuItem({
      allowRedelivery,
      location,
      enabledMenus,
      actionGridMenu,
      gridMenu,
      model,
      routeId
    }) {
      if (!allowRedelivery || !location) return null;
      if (!enabledMenus.isEnabled(actionGridMenu.UNDELIVERABLE_STOP))
        return null;
      return {
        id: 6,
        description: Monet.I18n.getResourcesByKey('stop.redeliveryStop'),
        icon: 'undeliverableStop',
        customClassname: 'UndeliverableStopItem',
        action: function () {
          const undeliverableStopPopup = new Greenmile.Stop.Undeliverable();
          gridMenu.removeAllMenus();
          undeliverableStopPopup.setStop(model);
          undeliverableStopPopup.setRouteId(routeId);
          undeliverableStopPopup.show();
        }
      };
    }

    function getShowStopRouteMenuItem(context) {
      const { route, stop } = context;
      return {
        id: 7,
        description: Monet.I18n.getResourcesByKey(
          'Greenmile.RouteDetail.GoToMarkLocation'
        ),
        icon: 'goToMark',
        customClassname: 'ShowStopRouteItem',
        action: function () {
          navigateToRouteDetailsFocusedOnStop(route, stop.toJSON());
          const screen = Monet.Session.RouteDetail.screensList[route.id];
          const mapRouteDetail = screen ? screen.mapRouteDetail : null;
          if (mapRouteDetail) {
            mapRouteDetail.focusOnTheStop(stop.attributes);
          }
        }
      };
    }

    this.getItemsToMenu = function (model) {
      const items = [];
      if (!model) return items;

      const enabledMenus = this.getEnabledMenu();
      const gridMenu = this.gridMenu;
      const route = model.get('route');
      const stop = new App.Models.Stop(model.get('stop'));
      const routeId = route.id;
      const routeStatus = route.status;
      const actualArrive = stop.get('actualArrival');
      const actualDeparture = stop.get('actualDeparture');
      const cancelCode = stop.get('cancelCode');
      const stopType = stop.get('stopType').type;
      const location = stop.get('location');

      let allowArrive = false;
      let allowDepart = false;
      let allowCancel = false;
      let allowRedelivery = false;

      if (
        !actualArrive &&
        !cancelCode &&
        routeStatus === 'DEPARTED_ORIGIN' &&
        !stop.getStopArrived()
      ) {
        allowArrive = true;
        allowCancel = true;
      } else if (
        actualArrive &&
        !actualDeparture &&
        !cancelCode &&
        routeStatus === 'DEPARTED_ORIGIN'
      ) {
        allowDepart = true;
        if (stopType === 'STOP') {
          allowRedelivery = true;
        }
      }

      // Create context object with all necessary data
      const menuContext = {
        // Menu infrastructure
        enabledMenus,
        gridMenu,
        actionGridMenu,

        // Route and stop data
        route,
        stop,
        model,
        routeId,
        location,

        // Permission flags
        allowArrive,
        allowDepart,
        allowCancel,
        allowRedelivery
      };

      const listOrdersItem = getListOrdersMenuItem(menuContext);
      if (listOrdersItem) items.push(listOrdersItem);

      const arriveMenuItem = getArriveMenuItem(menuContext);
      if (arriveMenuItem) items.push(arriveMenuItem);

      const cancelMenuItem = getCancelMenuItem(menuContext);
      if (cancelMenuItem) items.push(cancelMenuItem);

      const departMenuItem = getDepartMenuItem(menuContext);
      if (departMenuItem) items.push(departMenuItem);

      const redeliveryMenuItems = getRedeliveryStopMenuItem(menuContext);
      if (redeliveryMenuItems) items.push(redeliveryMenuItems);

      const undeliveryMenuItems = getUndeliverableStopMenuItem(menuContext);
      if (undeliveryMenuItems) items.push(undeliveryMenuItems);

      items.push(getShowStopRouteMenuItem(menuContext));

      return items;
    };
  }

  return Menu;
})();
